function Footer() {
  return (
    <div className="footer">
      <p>Created with ❤️ By:</p>
      <a
        href="https://ahmedbargady.me"
        target="_blank"
        rel="noopener noreferrer">
        Ahmed Bargady
      </a>
    </div>
  );
}

export default Footer;
